/**
 * @module @shared/config/query-keys
 * Zentrale, typsichere Query-Keys. Funktionen liefern `const`-Tupel, damit
 * Invalidierung über alle Slices konsistent bleibt.
 */

/** Query-Key-Factory für alle TanStack-Query-Caches der Login-App. */
export const queryKeys = {
  /** Branding-Daten einer App, adressiert über ihren Slug. */
  appBrand: (slug: string) => ['app-brand', slug] as const,
  /**
   * App-Übersicht des angemeldeten Nutzers (`/apps`).
   *
   * Die Slugs stammen aus dem `app_access`-Claim und gehören mit in den Key:
   * ein Kontowechsel oder eine neu freigeschaltete App ändert die Slug-Menge,
   * und das Ergebnis darf dann nicht die Cache-Zeile der vorherigen Menge
   * treffen. Ohne Argument bleibt der Key das reine Präfix `['my-apps']` —
   * genau die Adresse, über die sich alle Varianten gemeinsam invalidieren
   * lassen.
   *
   * @param slugs Sortierte App-Slugs aus dem Claim (Default: leer = Präfix).
   * @returns Stabiles `const`-Tupel `['my-apps', ...slugs]`.
   */
  myApps: (slugs: readonly string[] = []) => ['my-apps', ...slugs] as const,
  /**
   * Anwendungen, für die sich ein Zugang selbst anfragen lässt (`active` und
   * `self_service` im Verzeichnis).
   *
   * Bewusst ein eigener Key statt einer Variante von {@link queryKeys.myApps}:
   * diese Menge hängt nicht am Konto, sondern nur am Verzeichnis. Sie darf
   * deshalb über einen Kontowechsel hinweg im Cache bleiben und würde die
   * kontobezogenen `my-apps`-Zeilen sonst mit-invalidieren.
   *
   * @returns Stabiles `const`-Tupel `['requestable-apps']`.
   */
  requestableApps: () => ['requestable-apps'] as const,
} as const;
